// extracted by mini-css-extract-plugin
module.exports = {"ButtonWrapper":"Button_ButtonWrapper__1YXc2","ButtonLabel":"Button_ButtonLabel__3rNw1","highlighted":"Button_highlighted__Pqo99"};